import YourCompanies from './YourCompanies';

export default YourCompanies;
